// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_LIST,
  MEAL_ADD,
  MEAL_UPDATE,
  MEAL_DELETE,

  STAFF_ADD,
} from "../../config/constants"; // Adjust endpoints as per your config

const mealService = createApi({
  reducerPath: "mealService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Meal"],
  endpoints: (builder) => ({
    getMeals: builder.query({
      query: (bodyData) => ({
        url: MEAL_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Meal"],
    }),
    addMeal: builder.mutation({
      query: (mealData) => ({
        url: MEAL_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Meal"],
    }),

    addStaff: builder.mutation({
      query: (mealData) => ({
        url: STAFF_ADD, // Endpoint to add a staff
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Meal"],
    }),

    updateMeal: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${MEAL_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Meal"]
    }),
    deleteMeal: builder.mutation({
      query: (mealId) => ({
        url: `${MEAL_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Meal"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetMealsQuery,
  useAddMealMutation,
  useAddStaffMutation,
  useUpdateMealMutation,
  useDeleteMealMutation,
} = mealService;

// Export the reducer to be included in the store
export default mealService;
